import { useState } from 'react';
import Select from 'react-select'
import '../../addChallenges.css'

const BookingDiffLocations = (props) => {
    const [count, setCount] = useState(3);
    const [name, setName] = useState("🌍 Around the World");
    const [reward, setReward] = useState(100);
    const [duration, setDuration] = useState(30);
    
    const getChallenge = () => {
        return {
            id: "Booking different locations",
            name: name,
            description: "Complete bookings at " + count.toString() + " different locations",
            points: reward,
            count: count,
            isNew: true,
            cloudFunction: "challengeReserveDifferentLocations",
            order: 1,
            duration: duration,
            isVisible: true,
        }
    }

    return (
        <div className="challenge-card">
            <div className="ch-card title">Bookings Different Locations</div>
            <div className="ch-card row">Complete bookings at <input value={count} onChange={(ev) => setCount(ev.target.value)} name="hours" className="ch-card number" type="number"/> different locations</div>
            <div className="ch-card row">Name: <input value={name} onChange={(ev) => setName(ev.target.value)} className="ch-card text"/></div>
            <div className="ch-card row">Reward: <input value={reward} onChange={(ev) => setReward(ev.target.value)} className="ch-card number" type="number"/> EGP</div>
            <div className="ch-card row">Duration: <input value={duration} onChange={(ev) => setDuration(ev.target.value)} className="ch-card number" type="number"/> days</div>
            <button className="ch-card add-button" onClick={() =>{ props.addToList(getChallenge())}}>Add to list</button>
        </div>
    );
}

export default BookingDiffLocations;